module.exports = __webpack_public_path__ + "static/media/Boat.51f150ca.svg";